import { createAsyncThunk } from "@reduxjs/toolkit";
import { IQueryParams, getSearchQuery } from "../../../common";
import { axios_api } from "../../../api/axios-api";
import { IChartOfAccount } from "./charts-of-account.types";
import { closeLoaderWithMessage, openLoaderWithMessage } from "../../common";

const GET_ACCOUNTING_CHART_OF_ACCOUNTS_ENDPOINT= "/accounting/get-accounting-chart-of-accounts"
const UPSERT_ACCOUNTING_CHART_OF_ACCOUNTS_ENDPOINT = "/accounting/upsert-accounting-chart-of-accounts"

export const fetchChartOfAccountsListWithArgsAsync = createAsyncThunk<{ recordCount: number, data: IChartOfAccount[] }, IQueryParams>(
    'pos-bank-info/fetchChartOfAccountsListWithArgsAsync', async (queryParams: IQueryParams, thunkAPI) => {
        thunkAPI.dispatch(openLoaderWithMessage("Fetching Details...!"))

        const searchQuery = getSearchQuery(queryParams);
        const response = await axios_api.get(`${GET_ACCOUNTING_CHART_OF_ACCOUNTS_ENDPOINT}${searchQuery}`)
        const data = response.data.data;
        const count = response.data.totalRecords
        thunkAPI.dispatch(closeLoaderWithMessage())
        return { recordCount: count, data: data }
    },
)


export const upsertSingleChartOfAccountAsync = createAsyncThunk<IChartOfAccount, IChartOfAccount>(
    'pos-bank-info/upsertSingleChartOfAccountAsync', async (payload: IChartOfAccount, thunkAPI) => {
        thunkAPI.dispatch(openLoaderWithMessage("Saving Changes...!"))
        const response = await axios_api.post(UPSERT_ACCOUNTING_CHART_OF_ACCOUNTS_ENDPOINT, payload)
        thunkAPI.dispatch(fetchChartOfAccountsListWithArgsAsync({
            page: 1,
            rowsPerPage: 10
        }))
        thunkAPI.dispatch(closeLoaderWithMessage())
        return response.data
    },
)